export const getSettingsRequest_v1_schema = {
  type: 'string',
};
